import { render, staticRenderFns } from "./BMButton.vue?vue&type=template&id=3c6b4218&scoped=true&"
import script from "./BMButton.vue?vue&type=script&lang=js&"
export * from "./BMButton.vue?vue&type=script&lang=js&"
import style0 from "./BMButton.vue?vue&type=style&index=0&id=3c6b4218&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6b4218",
  null
  
)

export default component.exports